/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ArchivingSystemConfigDTO { 
    /**
     * Flag indicating whether archiving is enabled or not
     */
    enabled: boolean;
    /**
     * Flag indicating whether references will be checked when performing import
     */
    strictReferenceCheck: boolean;
    /**
     * Flag indicating whether ERSes will be checked when performing import (default true)
     */
    ersCheck: boolean;
    /**
     * Flag indicating whether archiving configuration is locked or not
     */
    locked?: boolean;
}

export class ClsArchivingSystemConfigDTO { 
    /**
     * Flag indicating whether archiving is enabled or not
     */
    enabled: boolean = undefined;
    /**
     * Flag indicating whether references will be checked when performing import
     */
    strictReferenceCheck: boolean = undefined;
    /**
     * Flag indicating whether ERSes will be checked when performing import (default true)
     */
    ersCheck: boolean = undefined;
    /**
     * Flag indicating whether archiving configuration is locked or not
     */
    locked?: boolean = undefined;
}

